import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import PropTypes from "prop-types";

import * as Connection from "./../libs/connections";
import Preloader from "./../components/global/Preloader";
import HeroBannerSmall from "./../components/HeroBannerSmall";
import ShowroomFullScreen from "./../components/ShowroomFullScreen";
import SectionOfferButtons from "./../components/SectionOfferButtons";
import SectionOfferContent from "./../components/SectionOfferContent";

import "../styles/sites/OfferTemplatePage.css";

import heroBackgroundSell from "../assets/backgrounds/hero-sell.jpg";
import heroBackgroundShort from "../assets/backgrounds/hero-short.jpg";
import heroBackgroundLong from "../assets/backgrounds/hero-long.jpg";
import mouse from "../assets/icons-main/mouse.png";

export default class OfferTemplatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: " ",
      loading: true,
      error: false
    };
    this.doResize = null;
  }

  offerScrollFunction = async () => {
    try {
      clearTimeout(this.doResize);
      const windowHeight = $(window).height() / 4;
      const element = $("#hero-element");
      var styleElem = document.head.appendChild(
        document.createElement("style")
      );
      this.doResize = setTimeout(() => {
        if (element !== null && element !== undefined) {
          const heightFromTop = $(window).scrollTop() - windowHeight;
          styleElem.innerHTML = `.page-offer-template.scroll:after {top: ${heightFromTop}px}`;
          $(".mouse").css("top", heightFromTop + "px");
          if (heightFromTop < 0) {
            styleElem.innerHTML = `.page-offer-template.scroll:after {top: ${0}px}`;
            $(".mouse").css("top", 0 + "px");
          }
        }
      }, 150);
    } catch (err) {
      this.setState({
        error: true
      });
    }
  };

  async componentDidMount() {
    (async () => {
      try {
        const response = await Connection.getSinglePage(this.props.type);
        this.setState({
          loading: false,
          pageTitle: response.title.rendered,
          sectionOfferContent: {
            upperText: {
              leftSide: response.acf.leftSide,
              rightSide: response.acf.rightSide
            },
            contentSingle: response.acf.contentSingle,
            textImageSection: response.acf.textImageSection
          },
          bannerShowRoom: response.acf.showroom
        });
      } catch (err) {
        this.setState({
          error: true
        });
      }
    })().catch(err => {
      console.error(err);
    });
  }

  componentWillUnmount() {
    $(window).off("scroll", this.offerScrollFunction);
  }

  render() {
    const { type } = this.props;
    if (this.state.error) {
      return <Redirect to="/error" />;
    } else {
      return (
        <div className="page-offer-template scroll">
          <img className="mouse" src={mouse} alt="" />
          <Preloader global loading={this.state.loading} />
          <HeroBannerSmall
            fromTop
            centerForce={type === "sell" ? true : false}
            backgroundImage={
              type === "long"
                ? heroBackgroundLong
                : type === "short"
                  ? heroBackgroundShort
                  : heroBackgroundSell
            }
            headerText={this.state.pageTitle}
          />
          {this.state.sectionOfferContent && (
            <SectionOfferContent
              data={this.state.sectionOfferContent}
              type={type}
            />
          )}
          {this.props.type !== "fleet" &&
            this.state.bannerShowRoom && (
              <ShowroomFullScreen
                backgroundImage={this.state.bannerShowRoom.photoUrl}
                text={
                  <div className="showroom-text">
                    <div className="container container-small">
                      <div className="row">
                        <div className="col-12">
                          <h5>
                            <span>{this.state.bannerShowRoom.titleMain}</span>
                            {this.state.bannerShowRoom.titleSecond}
                          </h5>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.bannerShowRoom.desc
                            }}
                          />
                          <Link
                            className="btn-general btn-general--primary"
                            to={this.state.bannerShowRoom.button.buttonUrl}
                          >
                            {this.state.bannerShowRoom.button.buttonText}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />
            )}
          <SectionOfferButtons type={type} />
        </div>
      );
    }
  }
}

OfferTemplatePage.propTypes = {
  type: PropTypes.oneOf(["short", "long", "sell", "fleet"])
};
